import {RELATIONS} from "./constants.js";
import {Join} from "./Join.js";

export const Attribute = function(modelType, name) {
    this.name = name;
    this.getFrom = function(instance) {
        return instance[this.name];
    };
    return this;
};

export const AttributeRelation = function(attribute, relation, foreignAttribute) {
    this.attribute = attribute;
    this.relation = relation;
    this.foreignAttribute = foreignAttribute;
};

export class ForeignKey {
    constructor(foreignModel, options) {
        this.foreignModel = foreignModel;
        this.foreignColumnName = options?.foreignColumnName || "id";
    }

    resolve(localModel, localAttributeName, localModels, foreignModels) {
        const localColumnName = localAttributeName + "_id";
        if (!localModel.columns.includes(localColumnName)) {
            throw new Error("Local model " + localModel + " does not have a column " + localColumnName);
        }
        return (new Join(
            new AttributeRelation(
                // e.g. Product, category_id
                new Attribute(localModel, localColumnName),
                RELATIONS.Many,
                // e.g. Product, category
                new Attribute(localModel, localAttributeName)
            ),
            new AttributeRelation(
                // e.g. Category, id
                new Attribute(this.foreignModel, "id"),
                RELATIONS.One,
                // e.g. Category, products
                new Attribute(this.foreignModel, localModel.pluralName)
            )
        )).join(
            Object.values(localModels),
            Object.values(foreignModels)
        );
    }
}
